import { useMemo } from 'react';
import type { CommunicationDocument, CommunicationItem } from '@all-manager/design-system-v2';
import type { ActivityTimelineFeed } from '../../../../../types';
import { useGetDocumentsByEntity } from '../../../api/useGetDocumentsByEntity';
import { cleanCommunicationComment } from '../../../utils/communicationComment';

type Props = {
  item: ActivityTimelineFeed;
};

export function toCommunicationItem(item: ActivityTimelineFeed): CommunicationItem {
  return {
    id: item.id ?? '',
    type: item.sub_type ?? 'other',
    title: item.title,
    comment: cleanCommunicationComment(item.sub_type, item.comment),
    date: item.date,
    provider_name: item.provider_name,
    contact_name: item.contact_name,
  };
}

export function useActivityTimelineCommunicationPreview(props: Props) {
  // Same query as ActivityTimelineDocumentsList: served from cache, feeds the full-view dialog.
  const { data } = useGetDocumentsByEntity(
    { communicationId: props.item.id ?? undefined },
    Boolean(props.item.has_documents)
  );

  const communication = useMemo(() => toCommunicationItem(props.item), [props.item]);

  const documents = useMemo<CommunicationDocument[]>(
    () => (data ?? []).map((doc) => ({ id: doc.id, name: doc.name, url: doc.file_url })),
    [data]
  );

  return {
    communication,
    documents,
  };
}
